module.exports = __webpack_public_path__ + "static/xkcd-f9ff53812ebbe11003f6bf86d3d08cb4.jpg";